;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .controller('RulesSettingsModalCtrl', RulesSettingsModalCtrl)

  function RulesSettingsModalCtrl(
    $scope,
    $uibModalInstance,
    $uibModal,
    $translate,
    logger,
    RuleFactory,
    ruleName,
    ErrorService
  ) {
    'ngInject'

    angular.extend($scope, {
      /*TODO i18n-053*/
      rankings: ['High', 'Medium', 'Low'],
      model: {
        likelihood: '',
        likelihood_custom: '',
        impact: '',
        impact_custom: '',
        confidence_level: '',
        confidence_level_custom: '',
        risk_description: '',
        recommendation: '',
        references: [],
        selected_likelihood: '',
        selected_impact: '',
        selected_confidence_level: '',
        added_reference: ''
      },
      overridden_rankings: false,
      tab_active: 'general',
      risk_edit: false,
      recommendation_edit: false,
      blankReference: {
        reference: ''
      }
    })

    // API
    angular.extend($scope, {
      loadDefaultRankings: loadDefaultRankings,
      loadCustomRankings: loadCustomRankings,
      resetRankings: resetRankings,
      update: update,
      cancel: cancel,
      addReference: addReference,
      deleteReference: deleteReference
    })

    function init() {
      _getRule().then(_maybeAddEmptyInnerForm)
    }

    function _getRule() {
      return RuleFactory.getRule(ruleName)
        .then(function (response) {
          $scope.model = response.data
          $scope.model.status = false

          // we need to use objects instead of primitives in order to support our current usage of ng-repeat
          var references = []
          _.forEach(response.data.references, function (reference) {
            references.push({ reference: reference })
          })
          $scope.model.references = angular.copy(references)

          loadDefaultRankings()

          if (
            $scope.model.likelihood_custom !== null ||
            $scope.model.impact_custom !== null ||
            $scope.model.confidence_level_custom !== null
          ) {
            $scope.overridden_rankings = true
            loadCustomRankings()
          }
        })
        .catch(ErrorService.processError)
    }

    function loadDefaultRankings() {
      $scope.model.selected_likelihood = $scope.model.likelihood
      $scope.model.selected_impact = $scope.model.impact
      $scope.model.selected_confidence_level = $scope.model.confidence_level
    }

    function loadCustomRankings() {
      if ($scope.model.likelihood_custom !== null) {
        $scope.model.selected_likelihood = $scope.model.likelihood_custom
      }
      if ($scope.model.impact_custom !== null) {
        $scope.model.selected_impact = $scope.model.impact_custom
      }
      if ($scope.model.confidence_level_custom !== null) {
        $scope.model.selected_confidence_level =
          $scope.model.confidence_level_custom
      }
    }

    function resetRankings() {
      if ($scope.overridden_rankings) {
        loadCustomRankings()
      } else {
        loadDefaultRankings()
      }
    }

    function _maybeAddEmptyInnerForm() {
      if ($scope.model.references.length === 0) {
        $scope.model.references.push(angular.copy($scope.blankReference))
      }
    }

    function addReference() {
      $scope.model.references.push(angular.copy($scope.blankReference))
    }

    function deleteReference(index) {
      if ($scope.model.references.length === 1) {
        $scope.model.references[0] = angular.copy($scope.blankReference)
      } else {
        $scope.model.references.splice(index, 1)
      }
    }

    function _saveRuleCustomization(ruleName, request) {
      RuleFactory.customizeRule(ruleName, request).then(function () {
        logger.logSuccess(
          $translate.instant('detail_assessRules_successfulSettingsUpdate')
        )
        $uibModalInstance.close()
      }, ErrorService.processError)
    }

    function _buildRequest(data) {
      var request = {}

      request.risk = data.risk
      request.recommendation = data.recommendation

      var references = []
      _.forEach(data.references, function (item) {
        if (item.reference !== '') {
          references.push(item.reference)
        }
      })
      request.references = angular.copy(references)

      if ($scope.overridden_rankings) {
        request.confidence_level = data.selected_confidence_level
        request.likelihood = data.selected_likelihood
        request.impact = data.selected_impact
      }

      return request
    }

    function update() {
      var request = _buildRequest($scope.model)

      RuleFactory.calculateSeverity(
        $scope.model.name,
        $scope.model.selected_impact,
        $scope.model.selected_likelihood
      )
        .then(function (response) {
          var newSeverity = response.data.severity
          var affectedVulns = response.data.vulnerabilities_affected
          var exceptionVulns = response.data.vulnerabilities_exceptions

          if ($scope.model.severity != newSeverity && affectedVulns > 0) {
            var modalInstance = $uibModal.open({
              templateUrl: 'views/rules/manage/modal_severity_update.html',
              controller: 'ModalRuleSeverityUpdateInstanceCtrl',
              size: 'md-sm',
              windowClass: 'modal-severity-update-modal-z-index',
              resolve: {
                newSeverity: function () {
                  return newSeverity
                },
                affectedVulns: function () {
                  return affectedVulns
                },
                exceptionVulns: function () {
                  return exceptionVulns
                },
                ruleId: function () {
                  return $scope.model.name
                }
              }
            })

            modalInstance.result.then(function (response) {
              request.override = response.override
              _saveRuleCustomization($scope.model.name, request)
            })
          } else {
            _saveRuleCustomization($scope.model.name, request)
          }
        })
        .catch(ErrorService.processError)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }

    init()
  }
})()
